import { render, staticRenderFns } from "./Esrs.vue?vue&type=template&id=4f70c22f&scoped=true"
import script from "./Esrs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Esrs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Esrs.vue?vue&type=style&index=0&id=4f70c22f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70c22f",
  null
  
)

/* custom blocks */
import block0 from "./Esrs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxTdRecursiveEsrs: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/td/recursiveEsrs.vue').default,IxSearchText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SearchText.vue').default,IxBtnAddIro: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/AddIro.vue').default,CsrdEsrsStatus: require('/home/runner/work/assessment-service/assessment-service/frontend/components/csrd/EsrsStatus.vue').default,CsrdIroCell: require('/home/runner/work/assessment-service/assessment-service/frontend/components/csrd/IroCell.vue').default,IxDataTable: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/DataTable.vue').default})
